import React from 'react';

export interface PaginationNavigationButtonProps {
    id?: string;
    disabled?: boolean;
    onClick: () => void;
    children?: React.ReactNode;
    /** Accessible name when visible label text is omitted (e.g. icon-only compact mode). */
    ariaLabel?: string;
    styles?: {
        default?: string;
        disabled?: string;
    };
}

export const PaginationNavigationButtonLiClass =
    'px-4 py-3 bg-background-surface rounded-lg outline outline-1 outline-offset-[-1px] outline-border-default inline-flex justify-center items-center gap-3 cursor-pointer hover:bg-background-default';
export const PaginationNavigationButtonLiClassDisabled =
    'px-4 py-3 bg-background-surface rounded-lg outline outline-1 outline-offset-[-1px] outline-border-default inline-flex justify-center items-center gap-3 cursor-not-allowed';

export const PaginationNavigationButton = (props: PaginationNavigationButtonProps) => {
    const liClass = props.disabled
        ? (props?.styles?.disabled ?? PaginationNavigationButtonLiClassDisabled)
        : (props?.styles?.default ?? PaginationNavigationButtonLiClass);
    return (
        <button
            id={props.id + '-pagination-nav-button'}
            type='button'
            className={liClass}
            aria-label={props.ariaLabel}
            onClick={props.disabled ? undefined : props.onClick}>
            {props.children}
        </button>
    );
};

export default PaginationNavigationButton;
